import { create } from 'zustand';

interface UsePassengerClassFilterProps {
	/** The trip the current selection belongs to, so a different sailing starts unfiltered. */
	ferryTripId?: string;
	passengerClassIds: string[];
	setPassengerClassIds(ids: string[]): void;
	clearPassengerClasses(): void;
	resetForTrip(ferryTripId: string): void;
}

/**
 * Which fare types the check-in lists are narrowed to.
 *
 * <p>Deliberately <b>not</b> persisted, unlike the sort settings beside it. A fare type belongs to
 * one vessel, so a selection carried into tomorrow's sailing would match nothing and empty the list
 * with nothing on screen saying why. It lives for the visit.</p>
 *
 * <p>Separate from <c>useFilterAddOn</c> because it is a different kind of filter: the add-on,
 * characteristic and vehicle-group filters each collapse the tabs into one filtered tab and so
 * exclude each other, while this one narrows the rows inside the tabs that are already there —
 * which is why it can sit alongside the status filter and the sorter rather than disabling them.</p>
 */
export const usePassengerClassFilter = create<UsePassengerClassFilterProps>(set => ({
	ferryTripId: undefined,
	passengerClassIds: [],
	setPassengerClassIds: (passengerClassIds: string[]) => {
		set(state => ({ ...state, passengerClassIds }));
	},
	clearPassengerClasses: () => {
		set(state => ({ ...state, passengerClassIds: [] }));
	},
	resetForTrip: (ferryTripId: string) => {
		set(() => ({ ferryTripId, passengerClassIds: [] }));
	},
}));
